<script setup lang="ts">
  defineProps({
    breadcrumbs: Array,
    sections: Array,
  });
</script>
<template>
  <main class="container">
    <SfBreadcrumbs :breadcrumbs="breadcrumbs" />
    <SectionRenderer :sections="sections" />
  </main>
</template>
<style scoped lang="scss">
  .sections-wrapper {
    gap: 0;

    & > :nth-child(odd):not(.block-banner) {
      background-color: var(--color-light-gray);
    }
  }

  .breadcrumbs {
    max-width: 1400px;
    margin: 0 auto;
  }

  @media(min-width: 993px) {
    .container {
      width: 100%;
      max-width: unset;
    }
  }
</style>